import { render, staticRenderFns } from "./WalmartPreviewShare.vue?vue&type=template&id=4569aeee&scoped=true"
import script from "./WalmartPreviewShare.vue?vue&type=script&lang=js"
export * from "./WalmartPreviewShare.vue?vue&type=script&lang=js"
import style0 from "./WalmartPreviewShare.vue?vue&type=style&index=0&id=4569aeee&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4569aeee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4569aeee')) {
      api.createRecord('4569aeee', component.options)
    } else {
      api.reload('4569aeee', component.options)
    }
    module.hot.accept("./WalmartPreviewShare.vue?vue&type=template&id=4569aeee&scoped=true", function () {
      api.rerender('4569aeee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/walmart/WalmartPreviewShare.vue"
export default component.exports